import React, { useState } from 'react';
import MarkRow from '../../components/AdminPortal/AssignmentMarks/MarkRow';
import { useGetAssignmentMarksQuery } from '../../features/assignment/assignmentApi';

const AssignmentMarks = () => {

 const {data:assignmentMarks, isLoading, isError} = useGetAssignmentMarksQuery();

  let content;

  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <tr>Something went wrong</tr>;
  }
  if (!isLoading && !isError && assignmentMarks.length === 0) {
    content = <tr>No assignment mark available</tr>;
  }
  if (!isLoading && !isError && assignmentMarks.length > 0) {
    content = assignmentMarks.map((assignment) => <MarkRow key={assignment.id} assignment={assignment}/>);
  }
    return (
        <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
            <div className="px-3 py-20 bg-opacity-10">
                <ul className="assignment-status">
                    <li>Total <span>{assignmentMarks?.length}</span></li>
                    <li>Pending <span>{assignmentMarks?.filter((assignment) => assignment.status === 'pending').length}</span></li>
                    <li>Mark Sent <span>{assignmentMarks?.filter((assignment) => assignment.status === 'published').length}</span></li>
                </ul>
                <div className="overflow-x-auto mt-4">
                    <table className="divide-y-1 text-base divide-gray-600 w-full">
                        <thead>
                            <tr>
                                <th className="table-th">Assignment</th>
                                <th className="table-th">Date</th>
                                <th className="table-th">Student Name</th>
                                <th className="table-th">Repo Link</th>
                                <th className="table-th">Mark</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-slate-600/50">
                          {content}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
    );
};

export default AssignmentMarks;